import axios from "axios";
import { convertToPlain } from "./funcionalidadesStrings";

const obtenerCampo = (objeto, ...claves) => {
  const claveEncontrada = claves.find(
    (clave) => objeto?.[clave] !== undefined && objeto?.[clave] !== null
  );

  return claveEncontrada ? objeto[claveEncontrada] : undefined;
};

export const normalizarTextoNotaWebMutual = (notaWeb) => {
  if (typeof notaWeb !== "string") {
    return "";
  }

  const notaTrim = notaWeb.trim();
  if (notaTrim === "") {
    return "";
  }

  const notaConvertida = convertToPlain(notaTrim).trim();
  return notaConvertida === "-" ? "" : notaConvertida;
};

export const obtenerNotaWebMutual = async (url, token, mutualCodigo) => {
  if (!url || !token || mutualCodigo === undefined || mutualCodigo === null) {
    return "";
  }

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const response = await axios.get(`${url}Mutuales/${mutualCodigo}`, config);
  const mutuales = Array.isArray(response.data) ? response.data : [];
  const mutual =
    mutuales.find(
      (item) =>
        Number(obtenerCampo(item, "codigo", "Codigo")) === Number(mutualCodigo)
    ) || mutuales[0];

  return normalizarTextoNotaWebMutual(
    obtenerCampo(mutual, "notaWeb", "NotaWeb")
  );
};
